const actions = {
  DASHBOARD_BEGIN: 'DASHBOARD_BEGIN',
  DASHBOARD_SUCCESS: 'DASHBOARD_SUCCESS',
  DASHBOARD_ERR: 'DASHBOARD_ERR',

  PIVOT_BEGIN: 'PIVOT_BEGIN',
  PIVOT_SUCCESS: 'PIVOT_SUCCESS',
  PIVOT_ERR: 'PIVOT_ERR',
  PROFIT_BEGIN: 'PROFIT_BEGIN',
  PROFIT_SUCCESS: 'PROFIT_SUCCESS',
  PROFIT_ERR: 'PROFIT_ERR',

  MONTHWISE_PROFIT_BEGIN: 'MONTHWISE_PROFIT_BEGIN',
  MONTHWISE_PROFIT_SUCCESS: 'MONTHWISE_PROFIT_SUCCESS',
  MONTHWISE_PROFIT_ERR: 'MONTHWISE_PROFIT_ERR',

  PROFITABILITY_BEGIN: 'PROFITABILITY_BEGIN',
  PROFITABILITY_SUCCESS: 'PROFITABILITY_SUCCESS',
  PROFITABILITY_ERR: 'PROFITABILITY_ERR',

  PROFITMODAL_BEGIN: 'PROFITMODAL_BEGIN',
  PROFITMODAL_SUCCESS: 'PROFITMODAL_SUCCESS',
  PROFITMODAL_ERR: 'PROFITMODAL_ERR',

  SET_DATE_RANGE: 'SET_DATE_RANGE',
  SET_SEARCH: 'SET_SEARCH',

  SET_CHANNEL: 'SET_CHANNEL',

  ESTIMATED_FEES_BEGIN: 'ESTIMATED_FEES_BEGIN',
  ESTIMATED_FEES_SUCCESS: 'ESTIMATED_FEES_SUCCESS',
  ESTIMATED_FEES_ERR: 'ESTIMATED_FEES_ERR',

  NOTIFICATION_BEGIN: 'NOTIFICATION_BEGIN',
  NOTIFICATION_SUCCESS: 'NOTIFICATION_SUCCESS',
  NOTIFICATION_ERR: 'NOTIFICATION_ERR',

  SUPPORT_TICKET_BEGIN: 'SUPPORT_TICKET_BEGIN',
  SUPPORT_TICKET_SUCCESS: 'SUPPORT_TICKET_SUCCESS',
  SUPPORT_TICKET_ERR: 'SUPPORT_TICKET_ERR',

  GET_SUPPORT_TICKET_BEGIN: ' GET_SUPPORT_TICKET_BEGIN',
  GET_SUPPORT_TICKET_SUCCESS: ' GET_SUPPORT_TICKET_SUCCESS',
  GET_SUPPORT_TICKET_ERR: ' GET_SUPPORT_TICKET_ERR',

  GET_TICKET_DETAILS_BEGIN: 'GET_TICKET_DETAILS_BEGIN',
  GET_TICKET_DETAILS_SUCCESS: ' GET_TICKET_DETAILS_SUCCESS',
  GET_TICKET_DETAILS_ERR: 'GET_TICKET_DETAILS_ERR',

  PROFIT_SKU_ID_BEGIN: 'PROFIT_SKU_ID_BEGIN',
  PROFIT_SKU_ID_SUCCESS: 'PROFIT_SKU_ID_SUCCESS',
  PROFIT_SKU_ID_ERR: 'PROFIT_SKU_ID_ERR',

  ACTION_REQUIRED_BEGIN: 'ACTION_REQUIRED_BEGIN',
  ACTION_REQUIRED_SUCCESS: 'ACTION_REQUIRED_SUCCESS',
  ACTION_REQUIRED_ERR: 'ACTION_REQUIRED_ERR',
  dashboardBegin: () => ({
    type: actions.DASHBOARD_BEGIN,
  }),

  dashboardSuccess: (data) => ({
    type: actions.DASHBOARD_SUCCESS,
    data,
  }),

  dashboardErr: (err) => ({
    type: actions.DASHBOARD_ERR,
    err,
  }),
  pivotBegin: () => ({ type: actions.PIVOT_BEGIN }),
  pivotSuccess: (data) => ({ type: actions.PIVOT_SUCCESS, data }),
  pivotErr: (err) => ({ type: actions.PIVOT_ERR, err }),

  profitmodalBegin: () => ({ type: actions.PROFITMODAL_BEGIN }),
  profitmodalSuccess: (data) => ({ type: actions.PROFITMODAL_SUCCESS, data }),
  profitmodalErr: (err) => ({ type: actions.PROFITMODAL_ERR, err }),

  profitBegin: () => ({ type: actions.PROFIT_BEGIN }),
  profitSuccess: (data) => ({ type: actions.PROFIT_SUCCESS, data }),
  profitErr: (err) => ({ type: actions.PROFIT_ERR, err }),

  profitSKUIdBegin: () => ({ type: actions.PROFIT_SKU_ID_BEGIN }),
  profitSKUIdSuccess: (data) => ({ type: actions.PROFIT_SKU_ID_SUCCESS, data }),
  profitSKUIdErr: (err) => ({ type: actions.PROFIT_SKU_ID_ERR, err }),

  actionRequiredBegin: () => ({ type: actions.ACTION_REQUIRED_BEGIN }),
  actionRequiredSuccess: (data) => ({ type: actions.ACTION_REQUIRED_SUCCESS, data }),
  actionRequiredErr: (err) => ({ type: actions.ACTION_REQUIRED_ERR, err }),

  monthwiseProfitBegin: () => ({
    type: actions.MONTHWISE_PROFIT_BEGIN,
  }),

  monthwiseProfitSuccess: (data) => ({
    type: actions.MONTHWISE_PROFIT_SUCCESS,
    data,
  }),

  monthwiseProfitErr: (err) => ({
    type: actions.MONTHWISE_PROFIT_ERR,
    err,
  }),
  setDateRange: (payload) => ({
    type: actions.SET_DATE_RANGE,
    payload,
  }),
  setSearch: (payload) => ({
    type: actions.SET_SEARCH,
    payload,
  }),
  setChannel: (payload) => ({
    type: actions.SET_CHANNEL,
    payload,
  }),

  profitabilityBegin: () => ({ type: actions.PROFITABILITY_BEGIN }),
  profitabilitySuccess: (data) => ({ type: actions.PROFITABILITY_SUCCESS, data }),
  profitabilityErr: (err) => ({ type: actions.PROFITABILITY_ERR, err }),

  estimatedFeesBegin: () => ({ type: actions.ESTIMATED_FEES_BEGIN }),
  estimatedFeesSuccess: (data) => ({ type: actions.ESTIMATED_FEES_SUCCESS, data }),
  estimatedFeesErr: (err) => ({ type: actions.ESTIMATED_FEES_ERR, err }),

  notificationBegin: () => ({ type: actions.NOTIFICATION_BEGIN }),
  notificationSuccess: (data) => ({ type: actions.NOTIFICATION_SUCCESS, data }),
  notificationErr: (err) => ({ type: actions.NOTIFICATION_ERR, err }),

  supportTicketsBegin: () => ({ type: actions.SUPPORT_TICKET_BEGIN }),
  supportTicketsSuccess: (data) => ({ type: actions.SUPPORT_TICKET_SUCCESS, data }),
  supportTicketsErr: (err) => ({ type: actions.SUPPORT_TICKET_ERR, err }),

  getsupportTicketsBegin: () => ({ type: actions.GET_SUPPORT_TICKET_BEGIN }),
  getsupportTicketsSuccess: (data) => ({ type: actions.GET_SUPPORT_TICKET_SUCCESS, data }),
  getsupportTicketsErr: (err) => ({ type: actions.GET_SUPPORT_TICKET_ERR, err }),

  getTicketsDetailsBegin: () => ({ type: actions.GET_TICKET_DETAILS_BEGIN }),
  getTicketsDetailsSuccess: (data) => ({ type: actions.GET_TICKET_DETAILS_SUCCESS, data }),
  getTicketsDetailsErr: (err) => ({ type: actions.GET_TICKET_DETAILS_ERR, err }),
};

export default actions;
